/**
 * Owner Properties service — wraps the /api/owner-properties endpoints.
 *
 * Saved properties that owners can re-book Property Checks against.
 */

import api from './api';

const unwrap = (response) => response?.data?.data ?? {};

const ownerPropertiesService = {
  /**
   * GET /api/owner-properties
   * @param {Object} [opts]
   * @param {boolean} [opts.includeArchived]
   * @returns Array of properties
   */
  async list({ includeArchived = false } = {}) {
    const res = await api.get('/owner-properties', {
      params: includeArchived ? { includeArchived: 'true' } : {},
    });
    return unwrap(res).properties || [];
  },

  /**
   * GET /api/owner-properties/:id
   */
  async get(id) {
    const res = await api.get(`/owner-properties/${id}`);
    return unwrap(res).property;
  },

  /**
   * POST /api/owner-properties
   * @param {Object} payload — { label, location, propertyType?, defaultAccessInfo?, defaultFocusAreas? }
   */
  async create(payload) {
    const res = await api.post('/owner-properties', payload);
    return unwrap(res).property;
  },

  /**
   * PATCH /api/owner-properties/:id
   */
  async update(id, patch) {
    const res = await api.patch(`/owner-properties/${id}`, patch);
    return unwrap(res).property;
  },

  /**
   * POST /api/owner-properties/:id/archive
   */
  async archive(id) {
    const res = await api.post(`/owner-properties/${id}/archive`);
    return unwrap(res);
  },

  /**
   * POST /api/owner-properties/:id/unarchive
   */
  async unarchive(id) {
    const res = await api.post(`/owner-properties/${id}/unarchive`);
    return unwrap(res);
  },
};

export default ownerPropertiesService;
